import { useTranslation } from 'react-i18next';
import { GoogleSignInButton } from './google-sign-in-button';
import type { GsiButtonConfiguration } from '../../types/google-accounts';

interface SocialSignInProps {
  onGoogleCredential: (credential: string) => void | Promise<void>;
  googleText?: GsiButtonConfiguration['text'];
}

// Social login options plus an "or" divider. Renders nothing when no provider is
// configured, so the surrounding email/password form stands on its own.
export function SocialSignIn({ onGoogleCredential, googleText }: SocialSignInProps) {
  const { t } = useTranslation();
  const googleEnabled = Boolean(import.meta.env.VITE_GOOGLE_CLIENT_ID);

  if (!googleEnabled) return null;

  return (
    <div className="space-y-4">
      <GoogleSignInButton onCredential={onGoogleCredential} text={googleText} />
      <div className="flex items-center gap-3">
        <span className="h-px w-full bg-border" />
        <span className="text-xs uppercase text-muted-foreground">{t('auth.or')}</span>
        <span className="h-px w-full bg-border" />
      </div>
    </div>
  );
}
